import script from "./RenderlessPagination.vue?vue&type=script&lang=js"
export * from "./RenderlessPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"platform/themes/staderecord/assets/js/components/utils/RenderlessPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "187c27a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('187c27a2', __exports__)) {
    api.reload('187c27a2', __exports__)
  }
  
}


export default __exports__